export default __webpack_public_path__ + "static/media/airhorn.4d210415.mp3";